import { Injectable } from '@angular/core';
import {TokenService} from "./token.service";

@Injectable({
  providedIn: 'root'
})
export class TokenMockService implements TokenService {

  private readonly token='9a1naa8xfCXSOhBIEFVURVKtks9T';

  public async getToken(): Promise<string>{
    return new Promise<string>((resolve, reject) =>{
      resolve(this.token);
    });
  }


}
